import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ViewDetails from './ViewDetails';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { area } from '@src/utils/area';

const FormInfo = ({ understand, understandHandle, languages }) => {
    const [confirmData, setConfirmData] = useState({
        isClickOk: understand,
        isCheck: false,
        isClosePopup: true,
    });
    const confirmDataHandle = (value) => {
        document.body.style.overflow = '';
        setConfirmData(value);

        understandHandle(value.isClickOk);
    };
    const viewDetailHandle = () => {
        document.body.style.overflow = '';
        setConfirmData({
            isClickOk: understand,
            isCheck: false,
            isClosePopup: false,
        });
    };

    return (
        <div className={styles.formInfo}>
            <div className={styles.limtTime}>{area[languages].limtTime}</div>
            <div
                className={styles.formInfoBox}
                onClick={() => {
                    viewDetailHandle(confirmData);
                }}>
                <div className={`${styles.formInfoIcon} ${understand ? styles.active : ''}`} />
                <div className={styles.formInfoText}>
                    {area[languages].declaration.title}
                    <span className={styles.formDetail}>{area[languages].declaration.moreText}</span>
                </div>
            </div>
            <ViewDetails languages={languages} confirmData={confirmData} confirmDataHandle={confirmDataHandle} />
        </div>
    );
};

FormInfo.propTypes = {
    understand: PropTypes.bool,
    understandHandle: PropTypes.func,
    languages: PropTypes.string,
};

export default errorBoundary(FormInfo);
